import { render, staticRenderFns } from "./Blocks.vue?vue&type=template&id=4fc9d52d&scoped=true"
import script from "./Blocks.vue?vue&type=script&lang=js"
export * from "./Blocks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fc9d52d",
  null
  
)

export default component.exports